<ng-container *ngIf="academicYearData$ | async as academicYearData">
    <sms-autocomplete
        [formControl]="selectedAcademicYear"
        [options]="academicYearData.rows || []"
        label="Academic year"
        field="name"
    ></sms-autocomplete>
</ng-container>
